import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Layouts from "../layouts/Layouts";
import PageBanner from "../components/PageBanner";
import DoctorDetails from "./DoctorDetails";
import { getDownloadURL, listAll, ref } from "firebase/storage";
import { db, storage } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useTranslation } from "react-i18next";
import { useRefContext } from "../components/ScrollToAppointment";
import useDoctors from "../hooks/useDoctorsList";

const Doctors = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const doctor = location.state?.doctor;
  const { images, doctors, loading, getTranslatedValue } = useDoctors();
  const { appointmentRef } = useRefContext();

  const showDoctors = () => (
    <section className="doctors-section bg-color-grey polygon-pattern-2">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-6" style={{ marginTop: "40px" }}>
            <div className="section-heading text-center mb-40">
              <h2 className="title">{t("aboutPage.ourTeam2")}</h2>
            </div>
          </div>
        </div>
        <div
          className="row justify-content-center doctors-loop"
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {doctors
            .sort((a, b) => a.priority - b.priority)
            .map((doctor, index) => (
              <div
                key={index}
                style={{
                  flex: "1 1 calc(25% - 20px)",
                  minWidth: "300px",
                  maxWidth: "calc(25% - 20px)",
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
              >
                <Link
                  className="doctor-box-three wow fadeInUp"
                  to={`/doctor`}
                  state={{ doctor }}
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "425px",
                    flexGrow: 1,
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="doctor-photo"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "150px",
                      height: "150px",
                      margin: "0 auto",
                    }}
                  >
                    <img
                      src={doctor?.thumbnailURL}
                      alt={`${doctor.name}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                  <div
                    className="doctor-information"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      flexGrow: 1,
                      marginTop: "20px",
                    }}
                  >
                    <div>
                      <h5 className="name">
                        <Link to={`/doctor`} state={{ doctor }}>
                          {getTranslatedValue(doctor.name, i18n.language)}
                        </Link>
                      </h5>
                      <span className="specialty">
                        {getTranslatedValue(doctor.role, i18n.language)}
                      </span>
                      <p
                        className="experience"
                        style={{ color: "var(--color-body)" }}
                      >
                        {getTranslatedValue(doctor.experience, i18n.language)}
                      </p>
                    </div>
                    {/* Know More Button */}
                    <div
                      className="read-more"
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "var(--color-fourth)",
                        padding: "10px 20px",
                        fontSize: "16px",
                        textAlign: "center",
                        marginTop: "20px",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                    >
                      <Link
                        to={`/doctor`}
                        state={{ doctor }}
                        style={{
                          color: "white",
                          textDecoration: "none",
                          width: "100%",
                          textAlign: "center",
                        }}
                      >
                        {t("home.bannerBoxButton2")}
                      </Link>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
        </div>
      </div>
    </section>
  );

  return (
    <Layouts footer={2} noheader>
      {doctor ? (
        <DoctorDetails doctor={doctor} imageUrls={images} />
      ) : (
        showDoctors()
      )}
    </Layouts>
  );
};

export default Doctors;
